export default __webpack_public_path__ + "static/media/BUSINESSBRANCHENBUCH.6c10a50b.png";